var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResetAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10696_16567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1665 3.3335V8.3335H14.1665",
    stroke: "#386097",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0751 12.4998C16.5334 14.0331 15.508 15.3488 14.1535 16.2486C12.799 17.1484 11.1888 17.5836 9.56541 17.4887C7.94205 17.3937 6.39352 16.7737 5.15319 15.7221C3.91286 14.6705 3.04792 13.2442 2.6887 11.6582C2.32949 10.0723 2.49546 8.41251 3.16161 6.92907C3.82777 5.44564 4.95801 4.2189 6.38202 3.43371C7.80604 2.64853 9.44667 2.34743 11.0567 2.5758C12.6667 2.80417 14.1589 3.54963 15.3084 4.69985L19.1667 8.33318",
    stroke: "#386097",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10696_16567"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetAll);
export default __webpack_public_path__ + "static/media/reset-all.3d4f05dcf7d0c3745f0158b28e04220d.svg";
export { ForwardRef as ReactComponent };